// 内部模块 - 工具
import { logger } from './logger';

// 内部模块 - API
import { getCurrentUserService } from '@/apis/authApi';

// 内部模块 - 常量
import { STORAGE_KEYS } from '@/constants/constants';

/**
 * Token 管理器
 * 单一职责：管理 token 的更新和刷新
 */
class TokenManager {
  constructor(accountStore) {
    this.accountStore = accountStore;
  }

  /**
   * 更新 ERP token
   * @param {string} newToken - 新的 token
   */
  updateErpToken(newToken) {
    if (this.accountStore.erpUserInfo) {
      this.accountStore.erpUserInfo.token = newToken;
      localStorage.setItem(
        STORAGE_KEYS.ERP_USER_INFO,
        JSON.stringify(this.accountStore.erpUserInfo)
      );
      logger.debug('[TokenManager] ERP token 已更新');
    }
  }

  /**
   * 刷新 token
   * @returns {Promise<boolean>} 刷新是否成功
   */
  refreshToken() {
    // 检查是否有有效的 token 进行刷新
    if (!this.accountStore.erpUserInfo?.token) {
      logger.warn('[TokenManager] 没有有效的 token 进行刷新');
      return Promise.resolve(false);
    }

    return getCurrentUserService({ showLoading: false })
      .then(userData => {
        // 根据第三方接口响应格式：{ success: true, code: 0, data: { token: "...", user: {...} } }
        // 但实际返回的是：{ token: "...", user: {...} }
        let token = null;
        if (userData?.data?.token) {
          // 标准格式：data.data.token
          token = userData.data.token;
        } else if (userData?.token) {
          // 直接格式：data.token
          token = userData.token;
        }

        if (token) {
          this.updateErpToken(token);
          logger.debug('[TokenManager] Token 刷新成功');
          return true;
        }
        logger.warn('[TokenManager] 响应中未找到 token，响应数据:', userData);
        return false;
      })
      .catch(error => {
        logger.error('[TokenManager] Token 刷新失败:', error);
        return false;
      });
  }

  /**
   * 检查响应中是否包含新 token 并自动更新
   * @param {Object} responseData - 响应数据
   */
  checkAndUpdateToken(responseData) {
    // 根据第三方接口响应格式：{ success: true, code: 0, data: { token: "...", user: {...} } }
    // 但实际返回的是：{ token: "...", user: {...} }
    let token = null;
    if (responseData?.data?.token) {
      // 标准格式：data.data.token
      token = responseData.data.token;
    } else if (responseData?.token) {
      // 直接格式：data.token
      token = responseData.token;
    }

    if (token) {
      this.updateErpToken(token);
      logger.debug('[TokenManager] 从响应中自动更新 token');
    }
  }
}

export { TokenManager };
